import styled from 'styled-components';
import Card from 'antd/lib/card';

export const StyledCard = styled(Card)`
  background-color: rgba(255,255,255,0.8);
  max-width: 300px;
  position: relative;
  z-index: 1;
`;
